import { render, staticRenderFns } from "./DirectList.vue?vue&type=template&id=a946555e&scoped=true&"
import script from "./DirectList.vue?vue&type=script&lang=js&"
export * from "./DirectList.vue?vue&type=script&lang=js&"
import style0 from "./DirectList.vue?vue&type=style&index=0&id=a946555e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a946555e",
  null
  
)

export default component.exports